import { render, staticRenderFns } from "./MuleexLogo.vue?vue&type=template&id=72cc5480&scoped=true"
import script from "./MuleexLogo.vue?vue&type=script&lang=js"
export * from "./MuleexLogo.vue?vue&type=script&lang=js"
import style0 from "./MuleexLogo.vue?vue&type=style&index=0&id=72cc5480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc5480",
  null
  
)

export default component.exports